import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SuccessComponent } from '../shared/modals/success/success.component';
import { ErrorComponent } from '../shared/modals/error/error.component';
import { CreateSeasonComponent } from '../shared/modals/create-season/create-season.component';
import { LoginComponent } from '../shared/modals/login/login.component';
import { CreateLeagueComponent } from '../shared/modals/create-league/create-league.component';
import { CreatePlayerComponent } from '../shared/modals/create-player/create-player.component';
import { ReviewDetailsComponent } from '../shared/modals/review-details/review-details.component';
import { CreateScorerComponent } from '../shared/modals/create-scorer/create-scorer.component';
import { CreateLeaguePlayerComponent } from '../shared/modals/create-league-player/create-league-player.component';
// import { AddVestComponent } from '../shared/modals/add-vest/add-vest.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
    
  modalRefSucess!: BsModalRef;
  modalRefError!: BsModalRef;
  modalRefResponse!: BsModalRef;
  modalRefCreateSeason!: BsModalRef;
  modalRefCreateSeasonLeague!: BsModalRef;
  modalRefLogin!: BsModalRef;
  modalRefRegister!: BsModalRef;
  modalRefCreateScorer!: BsModalRef;
  modalRefCreatePlayer!: BsModalRef;
  modalRefReviewDetails!: BsModalRef;
  modalRefCreateLeaguePlayer!: BsModalRef;

  constructor(
    private modalService: BsModalService
  ) {}


  openLogin(){
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    }

    return this.modalRefLogin = this.modalService.show(LoginComponent, config);
  }

	hideLogin(){
    if(this.modalRefLogin){
			this.modalRefLogin.hide();
    }
	}
    
  successModal(message: any){
    const initialState = {
      message,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered success-modal'
    }

    return this.modalRefSucess = this.modalService.show(SuccessComponent, config);
  }

	hideSuccessModal(){
    if(this.modalRefSucess){
			this.modalRefSucess.hide();
    }
	}

  errorModal(message: any){
    const initialState = {
      message,
    };
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal modal-dialog-centered success-modal'
    }

    return this.modalRefError = this.modalService.show(ErrorComponent, config);
  }

	hideErrorModal(){
    if(this.modalRefError){
			this.modalRefError.hide();
    }
	}

  openCreateSeason(){
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    }

    return this.modalRefCreateSeason = this.modalService.show(CreateSeasonComponent, config);
  }

	hideCreateSeason(){
    if(this.modalRefCreateSeason){
			this.modalRefCreateSeason.hide();
    }
	}

  openCreateSeasonLeague(season){
    const initialState = {
      season
    }
    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered create-league-modal'
    }

    return this.modalRefCreateSeasonLeague = this.modalService.show(CreateLeagueComponent, config);
  }

	hideCreateSeasonLeague(){
    if(this.modalRefCreateSeasonLeague){
			this.modalRefCreateSeasonLeague.hide();
    }
	}

  openCreateScorer(){
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    }

    return this.modalRefCreateScorer = this.modalService.show(CreateScorerComponent, config);
  }

	hideCreateScorer(){
    if(this.modalRefCreateScorer){
			this.modalRefCreateScorer.hide();
    }
	}

  openCreatePlayer(){
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    }

    return this.modalRefCreatePlayer = this.modalService.show(CreatePlayerComponent, config);
  }

	hideCreatePlayer(){
    if(this.modalRefCreatePlayer){
			this.modalRefCreatePlayer.hide();
    }
	}

  openCreateLeaguePlayer(league){
    const initialState = {
      league
    }
    const config: any = {
      backdrop: true,
      ignoreBackdropClick: true,
      initialState,
      class: 'modal-dialog-centered'
    }

    return this.modalRefCreateLeaguePlayer = this.modalService.show(CreateLeaguePlayerComponent, config);
  }

	hideCreateLeaguePlayer(){
    if(this.modalRefCreateLeaguePlayer){
			this.modalRefCreateLeaguePlayer.hide();
    }
	}

  openReviewDetails(payload, type, league){
    const initialState = {
      payload,
      type,
      league
    };

    const config: any = {
      initialState,
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    }

    return this.modalRefReviewDetails = this.modalService.show(ReviewDetailsComponent, config);
  }

	hideReviewDetails(){
    if(this.modalRefReviewDetails){
			this.modalRefReviewDetails.hide();
    }
	}
}
